<template>
<svg width="23.4" height="23.4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="9.75" transform="rotate(-90 10 10)" stroke="#FA5C7C" stroke-width="0.5"/>
<rect x="5" y="9.3999" width="10" height="1.2" rx="0.6" fill="#FA5C7C"/>
</svg>
</template>

<script>
export default {

}
</script>


<style scoped lang="scss">
svg {
    rect,circle {
        transition: all 0.2s ease;
    }
    &:hover {
        rect {
            fill: #ffffff;
        }
        circle {
            fill: #FA5C7C;
        }
    }
}
</style>